<template>
  <div
    class="field"
    :class="additionalClasses"
  >
    <label :for="_uid">{{ label }}</label>
    <ValidationProvider
      v-slot="{ validate, errors }"
      :rules="rules"
    >
      <div class="select">
        <template v-if="hasGroups === true">
          <select
            :id="_uid"
            v-model="value"
            :required="required"
            :class="{'error': errors.length}"
            @blur="validate"
            @input="$emit('input', $event.target.value), validate($event)"
          >
            <optgroup
              v-for="(option, i) in options"
              :key="i"
              :label="option.name"
            >
              <option
                v-for="(awardValue, awardKey, j) in option.data"
                :key="j"
                :value="awardKey"
              >
                {{ awardValue }}
              </option>
            </optgroup>
          </select>
        </template>

        <template v-else>
          <select
            :id="_uid"
            v-model="value"
            :required="required"
            :class="{'error': errors.length}"
            @blur="validate"
            @input="$emit('input', $event.target.value), validate($event)"
          >
            <option
              v-for="(optName, optValue, i) in options"
              :key="i"
              :value="useNameAsValue ? optName : optValue"
            >
              {{ optName }}
            </option>
          </select>
        </template>
      </div>
      <div v-if="errors.length" class="error__text">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
    <pre style="display: none">{{ value }}</pre>
  </div>
</template>

<script>
import usesValidation from '@/mixins/veeValidate'
export default {

  name: 'DSSelect',

  mixins: [usesValidation],

  props: {
    label: {
      type: String,
      required: true,
    },
    hasGroups: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: [Object, Array],
      default: () => {
        'value', 'Label'
      },
    },
    required: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: 'required',
    },
    value: {
      type: String,
      default: '',
    },
    useNameAsValue: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    additionalClasses() {
      return {
        required: this.required,
      }
    },
  },
}
</script>
